import { render, staticRenderFns } from "./loan-overdue-remark.vue?vue&type=template&id=7fb2e6be&"
import script from "./loan-overdue-remark.vue?vue&type=script&lang=js&"
export * from "./loan-overdue-remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports